// extracted by mini-css-extract-plugin
export var animationContainer = "_p1-0";
export var footer = "_p1-1";
export var gray = "_p1-2";
export var lineItem = "_p1-3";
export var lineItemImage = "_p1-4";
export var lineItemInfo = "_p1-5";
export var lineItemText = "_p1-6";
export var lineItems = "_p1-7";
export var modalContent = "_p1-8";
export var options = "_p1-9";
export var orderName = "_p1-a";
export var refundAmount = "_p1-b";